var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShow)?_c('Banner',{attrs:{"banner-message":_vm.bannerMessage,"href-link":_vm.bannerLink,"href-link-text":_vm.bannerLinkText,"color-scheme":_vm.colorScheme,"close-button-label":_vm.$t('STATUS_PAGE.CLOSE'),"has-close-button":""},on:{"close":_vm.onDismiss}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }